// Pure (tiptap-free) RedGifs URL helpers, extracted from RedGifs.ts so the main
// barrel can re-export them without dragging @tiptap/core into the eager bundle.
// The tiptap extension definition (`RedGifs`) stays in RedGifs.ts.

export const REDGIFS_REGEX_GLOBAL = /https?:\/\/(?:www\.)?redgifs\.com\/watch\/[a-zA-Z0-9_-]+[^\s]*/gi

export type RedGifsUrlMetadata = {
  normalizedUrl: string
  id: string
  passthroughParams: URLSearchParams
}

export function getRedGifsUrlMetadata(url: string): RedGifsUrlMetadata | null {
  try {
    const parsedUrl = new URL(url.trim())
    if (!['redgifs.com', 'www.redgifs.com'].includes(parsedUrl.hostname)) {
      return null
    }

    const id = parsedUrl.pathname.match(/^\/watch\/([a-zA-Z0-9_-]+)\/?$/)?.[1] ?? null
    if (!id) {
      return null
    }

    return {
      normalizedUrl: parsedUrl.toString(),
      id,
      passthroughParams: new URLSearchParams(parsedUrl.search),
    }
  } catch {
    return null
  }
}

// Returns the provider embed URL when `url` is a recognized RedGifs watch URL, otherwise `null`.
// The no-match branch must NOT fall back to the raw input: the render nodes feed this straight into an
// iframe `src`, so returning the unvalidated url reintroduces the stored-XSS scheme it is meant to gate.
export function getEmbedUrlFromRedGifsUrl(url: string): string | null {
  const metadata = getRedGifsUrlMetadata(url)
  if (metadata) {
    const embedUrl = new URL(`https://redgifs.com/ifr/${metadata.id}`)
    for (const [key, value] of metadata.passthroughParams.entries()) {
      embedUrl.searchParams.append(key, value)
    }

    return embedUrl.toString()
  }

  return null
}

export function isValidRedGifsUrl(url: string) {
  return getRedGifsUrlMetadata(url) !== null
}
